import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { BusinessType, MerchantField } from "../../types";

import { countryListBusinessTypeMap } from "./constants";

export class BusinessTypeField extends Field<BusinessType> {
  constructor(
    model: Merchant,
    opts: Partial<MerchantField<BusinessType>> = {}
  ) {
    super(model, {
      dataType: "string",
      propertyName: "businessType",
      uiFieldType: "Select",
      applicable: true,
      required: true,
      shown: true,
      ...opts,
    });
  }

  get pickList(): BusinessType[] {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return registeredCountry
      ? countryListBusinessTypeMap[registeredCountry]
      : [];
  }
}
